// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__2H6c0","First":"Table_First__2aQyL","Row":"Table_Row__2EJzt","Block":"Table_Block__3SrXR","Final":"Table_Final__36L70","Total":"Table_Total__2vAv8"};